/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-events/content-control-studio-events.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.events::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.events::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.events::-webkit-scrollbar-corner {
  background: transparent;
}
.events::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.events::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.events::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.events::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.events::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
::ng-deep .mat-mdc-menu-panel {
  max-width: unset !important;
  width: 350px !important;
}
::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-content ul {
  list-style: none;
  padding-inline-start: 20px;
  padding: 0;
  -webkit-user-select: none;
  user-select: none;
}
::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-content ul li {
  margin: 5px 10px;
  width: 320px;
  padding-left: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: center;
}
::ng-deep .mat-mdc-menu-panel .mat-mdc-menu-content ul li input {
  width: 40px;
}
:host {
  padding: 20px 10px 0px 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.header h2 {
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
}
.events {
  outline: none;
  max-height: 85vh;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.events .selected {
  border: rgb(45, 187, 252) solid 2.5px;
}
.events-wrapper {
  border-radius: 6px;
  border-style: solid;
  width: 100%;
  border-color: rgba(0, 0, 0, 0.14);
  border-width: 1px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  -webkit-user-select: none;
  user-select: none;
}
.events-wrapper .selected {
  border-color: rgb(45, 187, 252);
}
.events-wrapper .multi-event {
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.events-wrapper .multi-event .data {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.events-wrapper .multi-event .data .more-arrow {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  cursor: pointer;
}
.events-wrapper .multi-event .data .more-arrow.open {
  animation: rotate90 0.1s forwards;
  transform-origin: center;
}
.events-wrapper .multi-event .data .info {
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  justify-content: center;
  display: flex;
  position: relative;
}
.events-wrapper .multi-event .data .info .timetrange {
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  position: relative;
  -webkit-user-select: text;
  user-select: text;
}
.events-wrapper .multi-event .data .info .title {
  background-color: #ef5d5d;
  border-radius: 4px;
  padding: 0px 4px 0px 4px;
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
}
.events-wrapper .multi-event .data .info .title.approved {
  background-color: #01b25d;
}
.events-wrapper .multi-event .data .info .title > span {
  color: rgb(255, 255, 255);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  position: relative;
}
.events-wrapper .multi-event .frames {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.events-wrapper .multi-event .frames img {
  border-radius: 4px;
  flex-shrink: 0;
  width: 82px;
  height: 46px;
  position: relative;
  object-fit: cover;
}
.events-wrapper ul {
  list-style: none;
  padding-inline-start: 20px;
  padding: 0;
  width: 100%;
}
.events-wrapper ul li {
  margin: 5px 0;
  width: 100%;
  padding-left: 5px;
}
.events-wrapper ul.hidden {
  display: none;
}
/*# sourceMappingURL=content-control-studio-events.component.css.map */
